import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

interface ModalConfirmacionProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  titulo: string;
  mensaje: string;
  variante?: 'warning' | 'error';
  colorBoton?: string;
}

const ModalConfirmacion: React.FC<ModalConfirmacionProps> = ({
  open,
  onClose,
  onConfirm,
  titulo,
  mensaje,
  variante,
  colorBoton,
}) => {
  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose} sx={{ pr: 3, pb: 3 }}>
      <DialogTitle fontSize={18} fontWeight="bold" color={variante} maxWidth="310px">
        {titulo}
      </DialogTitle>
      <DialogContent>
        <DialogContentText pb={1}>{mensaje}</DialogContentText>
        {/* <DialogContentText>¿Deseás continuar?</DialogContentText> */}
      </DialogContent>
      <DialogActions>
        <Box display="flex" gap="10px" p={2}>
          <Button variant="outlined" color="info" onClick={onClose}>
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            color={variante || 'error'}
            onClick={onConfirm}
            sx={{ backgroundColor: colorBoton }}
          >
            Confirmar
          </LoadingButton>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmacion;
